// import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
// import { Box, TextField, Typography, Button, CircularProgress, useTheme } from "@mui/material";
// import CryptoJS from "crypto-js";

// const AppEmergencyContact = forwardRef(({ handleFieldChange, initialData }, ref) => {
//   const theme = useTheme();
//   const [formData, setFormData] = useState({
//     emergency_contact_name1: "",
//     emergency_person_relation1: "",
//     emergency_contact_number1: "",
//     emergency_contact_name2: "",
//     emergency_person_relation2: "",
//     emergency_contact_number2: "",
//   });
//   const [loading, setLoading] = useState(false);
//   const [successMessage, setSuccessMessage] = useState("");
//   const [errorMessage, setErrorMessage] = useState("");

//   // Load initial data
//   useEffect(() => {
//     if (initialData) {
//       setFormData((prev) => ({ ...prev, ...initialData }));
//     }
//   }, [initialData]);

//   // Handle input changes
//   const handleChange = (event) => {
//     const { name, value } = event.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//     handleFieldChange("emergencyContact", name, value);
//   };

//   // Decrypt API Key
//   const getDecryptedAPIKey = () => {
//     const encryptedapikey = sessionStorage.getItem("encrypted_data");
//     const base64Key = sessionStorage.getItem("base64_Key");
//     if (base64Key && encryptedapikey) {
//       const key = CryptoJS.enc.Base64.parse(base64Key);
//       const dataBytes = CryptoJS.enc.Base64.parse(encryptedapikey);
//       const iv = CryptoJS.lib.WordArray.create(dataBytes.words.slice(0, 4));
//       const ciphertext = CryptoJS.lib.WordArray.create(dataBytes.words.slice(4));
//       const decryptedBytes = CryptoJS.AES.decrypt({ ciphertext }, key, { iv });
//       return CryptoJS.enc.Utf8.stringify(decryptedBytes);
//     }
//     return "";
//   };

//   // Handle form submission
//   const handleSubmit = async () => {
//     setLoading(true);
//     try {
//       const decryptedjwt = getDecryptedAPIKey();
//       const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/add-emergency-contact`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "X-API-Key": decryptedjwt,
//           'Authorization': `Bearer ${accessToken}`
//         },
//         body: JSON.stringify(formData),
//       });

//       const data = await response.json();
//       if (response.ok) {
//         //setSuccessMessage("Emergency contact details saved successfully!");
//         return formData;
//       } else {
//         console.log(data.error || "Error occurred while saving emergency contact details.");
//         return false;
//       }
//     } catch (error) {
//       setErrorMessage("An error occurred while inserting emergency contact details.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useImperativeHandle(ref, () => ({
//     handleSubmit,
//   }));

//   return (
//     <Box sx={{ maxWidth: 800, margin: "50px auto", padding: 2 }}>
//       {loading && (
//         <Box
//           sx={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100vw",
//             height: "100vh",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 1000,
//           }}
//         >
//           <CircularProgress color="primary" />
//         </Box>
//       )}

//       <Typography variant="h5" align="center" sx={{ fontWeight: "bold", color: theme.palette.text.primary }}>
//         Add Emergency Contact
//       </Typography>

//       <Box component="form" sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
//         {[
//           { field: "emergency_contact_name1", label: "Emergency Contact Name 1" },
//           { field: "emergency_person_relation1", label: "Emergency Person Relation 1" },
//           { field: "emergency_contact_number1", label: "Emergency Contact Number 1" },
//           { field: "emergency_contact_name2", label: "Emergency Contact Name 2" },
//           { field: "emergency_person_relation2", label: "Emergency Person Relation 2" },
//           { field: "emergency_contact_number2", label: "Emergency Contact Number 2" },
//         ].map(({ field, label }) => (
//           <TextField
//             key={field}
//             name={field}
//             label={label}
//             value={formData[field]}
//             onChange={handleChange}
//             fullWidth
//             variant="outlined"
//             InputLabelProps={{
//               shrink: true,
//               sx: {
//                 color: theme.palette.mode === "dark" ? "#fff" : "inherit",
//                 "&.Mui-focused": {
//                   color: theme.palette.mode === "dark" ? "#fff" : theme.palette.primary.main,
//                 },
//               },
//             }}
//             sx={{
//               "& .MuiOutlinedInput-root": {
//                 borderRadius: 2,
//                 backgroundColor:
//                   theme.palette.mode === "dark" ? "" : theme.palette.background.default,
//                 color: theme.palette.text.primary,

//                 "&.Mui-focused": {
//                   backgroundColor: theme.palette.mode === "dark" ? "hsla(180, 17.20%, 25.10%, 0.92)" : "#f5f5f5",
//                 },

//                 "& fieldset": {
//                   borderColor:
//                     theme.palette.mode === "dark"
//                       ? ""
//                       : "#ccc",
//                 },
//                 "&:hover fieldset": {
//                   borderColor: theme.palette.primary.main,
//                 },
//                 "&.Mui-focused fieldset": {
//                   borderColor: theme.palette.mode === "dark" ? "white" : "#f5f5f5",
//                 },
//               },
//               "& .MuiInputBase-input": {
//                 color: theme.palette.text.primary,
//               },
//             }}
//           />
//         ))}
//       </Box>

//       {successMessage && <Typography sx={{ mt: 2, color: "green", textAlign: "center" }}>{successMessage}</Typography>}
//       {errorMessage && <Typography sx={{ mt: 2, color: "red", textAlign: "center" }}>{errorMessage}</Typography>}
//     </Box>
//   );
// });

// export default AppEmergencyContact;

import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  TextField,
  Typography,
  Grid,
  Container,
  CardContent,
  useTheme,
} from "@mui/material";
import { tokens } from "../../../../../theme";

const AppEmergencyContact = forwardRef(({ handleFieldChange }, ref) => {
  const theme = useTheme();
   const colors = tokens(theme.palette.mode);
  const params = useParams();
  const navigate = useNavigate();
  const employee_id = params.employee_id || params.employeeId;

  const [formData, setFormData] = useState({
    corporate_email_id: "",
    emergency_contact_name1: "",
    emergency_person_relation1: "",
    emergency_contact_number1: "",
    emergency_contact_name2: "",
    emergency_person_relation2: "",
    emergency_contact_number2: "",
  });

  const [loading, setLoading] = useState(!!employee_id);
  const [errorMessage, setErrorMessage] = useState({});
  const [recordExists, setRecordExists] = useState(false); // used only for disabling inputs if not found

  // Style helpers
  const customInputSx = {
      borderRadius: "8px",
      backgroundColor: "transparent",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#aaa"
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#aaa !important"
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#aaa !important"
      }
    };

    const customLabelSx = {
      fontSize: "18px",
      fontWeight: "bold",
      color: colors.grey[100],
      "&.Mui-focused": {
        color: colors.grey[100]
      },
      "&.MuiInputLabel-shrink": {
        color: colors.grey[100]
      }
    };

  // Fetch data in edit mode
  useEffect(() => {
    if (!employee_id) return;

    let isMounted = true;

    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL_HRM}/emergency-contact/${employee_id}`
        );
        if (!response.ok) throw new Error("Failed to fetch emergency contact");

        const data = await response.json();

        if (data && isMounted) {
          setFormData({
            corporate_email_id: data.corporate_email_id || "",
            emergency_contact_name1: data.emergency_contact_name1 || "",
            emergency_person_relation1: data.emergency_person_relation1 || "",
            emergency_contact_number1: data.emergency_contact_number1 || "",
            emergency_contact_name2: data.emergency_contact_name2 || "",
            emergency_person_relation2: data.emergency_person_relation2 || "",
            emergency_contact_number2: data.emergency_contact_number2 || "",
          });
          setRecordExists(true);
        } else if (isMounted) {
          setRecordExists(false);
        }
      } catch (error) {
        console.error("Error fetching emergency contact:", error);
        if (isMounted) {
          setErrorMessage("Failed to load emergency contact data.");
          setRecordExists(false);
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [employee_id]);

  // Form input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrorMessage((prev) => ({ ...prev, [name]: "" }));
    if (!employee_id && handleFieldChange) {
      handleFieldChange("emergencyContact", name, value);
    }
  };

  const handleSave = async (corporateEmail) => {
    setLoading(true);
    if (!validateForm()) return false;
    try {
      const accessToken = JSON.parse(localStorage.getItem("emsUser"))?.user
        ?.stsTokenManager?.accessToken;

      const payload = {
        ...formData,
        corporate_email_id: corporateEmail,
      };

      if (!payload.corporate_email_id) {
        setErrorMessage("Corporate email ID is missing.");
        return false;
      }

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL_HRM}/add-emergency-contact`,
        {
          method: "POST",
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();
      if (response.ok && result.status === "success") {
        return payload;
      } else {
        const msg = result.message || "Failed to save emergency contact.";
        setErrorMessage(msg);
        return false;
      }
    } catch (error) {
      setErrorMessage(
        "An error occurred while saving emergency contact details."
      );
      return false;
    } finally {
      setLoading(false);
    }
  };

    const handleUpdate = async () => {
      if (!validateForm()) return false;
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL_HRM}/update-emergency-contact/${employee_id}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          }
        );

        const result = await response.json();
        if (response.ok) {
          if (result.updated === false || result.message === "No changes detected.") {
            return true;
          }
          navigate(-1);
          return true;
        } else {
          setErrorMessage("Failed to update emergency contact.");
          console.error(result);
          return false;
        }
      } catch (error) {
        setErrorMessage("Error updating emergency contact. Please try again.");
        console.error("Error updating emergency contact:", error);
        return false;
      }
    };


  const validateForm = () => {
    const newErrors = {};

    // Validate required fields (1's) — must be present and valid
    if (
      !formData.emergency_contact_name1 ||
      !/^[A-Za-z\s]+$/.test(formData.emergency_contact_name1)
    ) {
      newErrors.emergency_contact_name1 =
        "Name must contain only letters and spaces.";
    }

    if (!formData.emergency_person_relation1) {
      newErrors.emergency_person_relation1 = "Relation is required.";
    }

    if (
      !formData.emergency_contact_number1 ||
      !/^\d{10}$/.test(formData.emergency_contact_number1)
    ) {
      newErrors.emergency_contact_number1 =
        "Contact number must be exactly 10 digits.";
    }

    // Validate optional fields (2's) — only if present, then validate
    if (
      formData.emergency_contact_name2 &&
      !/^[A-Za-z\s]+$/.test(formData.emergency_contact_name2)
    ) {
      newErrors.emergency_contact_name2 =
        "Name must contain only letters and spaces.";
    }

    if (
      formData.emergency_person_relation2 &&
      !formData.emergency_person_relation2.trim()
    ) {
      newErrors.emergency_person_relation2 =
        "Relation must not be empty if provided.";
    }

    if (
      formData.emergency_contact_number2 &&
      !/^\d{10}$/.test(formData.emergency_contact_number2)
    ) {
      newErrors.emergency_contact_number2 =
        "Contact number must be exactly 10 digits.";
    }

    setErrorMessage(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  useImperativeHandle(ref, () => ({
    savedata: async (corporateEmail) => {
      return await handleSave(corporateEmail);
    },

    update: async () => {
        const result = await handleUpdate(); 
        return result; 
    },
    validate: validateForm,
  }));


  return (
    <Container maxWidth="md" sx={{ mt: 5 }}>
      <Typography
        variant="h5"
        align="center"
        sx={{ fontWeight: "bold", mb: 2 }}
      >
        {employee_id ? "Edit Emergency Contact" : "Add Emergency Contact"}
      </Typography>
      <CardContent>
        <Grid container spacing={2}>
          {[
            {
              label: "Emergency Contact Name 1",
              name: "emergency_contact_name1",
            },
            { label: "Relation 1", name: "emergency_person_relation1" },
            { label: "Contact Number 1", name: "emergency_contact_number1" },
            {
              label: "Emergency Contact Name 2",
              name: "emergency_contact_name2",
            },
            { label: "Relation 2", name: "emergency_person_relation2" },
            { label: "Contact Number 2", name: "emergency_contact_number2" },
          ].map(({ label, name }) => (
            <Grid item xs={12} sm={6} md={4} key={name}>
              <TextField
                fullWidth
                label={label}
                name={name}
                value={formData[name] || ""}
                onChange={handleChange}
                error={Boolean(errorMessage[name])}
                helperText={
                  errorMessage[name] && typeof errorMessage[name] === "string"
                    ? errorMessage[name]
                    : ""
                }
                variant="outlined"
                disabled={employee_id && !recordExists}
                InputLabelProps={{
                  shrink: true,
                  sx: customLabelSx,
                }}
                sx={{
                  ...customInputSx,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                    backgroundColor:
                      theme.palette.mode === "dark"
                        ? ""
                        : theme.palette.background.default,
                    color: theme.palette.text.primary,
                    "&.Mui-focused": {
                      backgroundColor:
                        theme.palette.mode === "dark"
                          ? "hsla(180, 17.20%, 25.10%, 0.92)"
                          : "#f5f5f5",
                    },
                    "& fieldset": {
                      borderColor: theme.palette.mode === "dark" ? "" : "#ccc",
                    },
                    "&:hover fieldset": {
                      borderColor: theme.palette.primary.main,
                    },
                    "&.Mui-focused fieldset": {
                      borderColor:
                        theme.palette.mode === "dark" ? "white" : "#f5f5f5",
                    },
                  },
                  "& .MuiInputBase-input": {
                    color: theme.palette.text.primary,
                  },
                }}
              />
            </Grid>
          ))}
        </Grid>
      </CardContent>
          {/* {Object.keys(errorMessage).length > 0 && (
            <Typography color="error" align="center" mt={2}>
              {Object.values(errorMessage).join(', ')}
            </Typography>
          )} */}
    </Container>
  );
});

export default AppEmergencyContact;
